import Factory from '../utils/factory'

export default Factory({
  value: null,
  included: false,
})
